import styled from 'styled-components';

const Container = styled.div`
  min-height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 4rem;

  @media (max-width: 1080px) {
    padding: 0 2rem;
  }
`;

const Main = styled.main`
  width: 100%;
  min-width: 0;

  /* Escala de título padronizada para todas as telas da área logada. */
  h1 {
    font-size: 2.8rem;
    font-weight: 700;
  }
`;

const MainContainer = styled.div`
  display: grid;
  grid-template-columns: 22rem 1fr;
  gap: 4rem;
  max-width: var(--content-max);
  margin: 4rem auto 8rem;
  width: 100%;
  flex: 1;

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
    gap: 0;
    margin: 3rem auto 6rem;
  }
`;

const MenuContainer = styled.div`
  position: sticky;
  top: calc(var(--header-h) + 2rem);
  align-self: start;

  @media (max-width: 800px) {
    display: none;
  }
`;

export { Container, Main, MainContainer, MenuContainer };
